import { SearchOutline24Icon } from "@vygruppen/spor-icon-react";
import { OploggSearch } from "features/TodoOploggSidebar/Oplogg/OploggSearch";
import { OploggSendMessage } from "features/TodoOploggSidebar/Oplogg/OploggSendMessage";
import { useOplogg } from "features/TodoOploggSidebar/Oplogg/useOplogg";
import { SearchResultText } from "features/VehicleSidebar/VehicleList/common/SearchResultText";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Flex, VStack } from "shared/components/Spor";
import { SectionButton } from "shared/components/buttons/SectionButton";
import { sum } from "shared/utils/arrayUtils";
import { useTheme } from "styled-components";

export const OpLoggInput = () => {
  const { setSelectedDateTime, setSearchString, searchString, data } =
    useOplogg();
  const theme = useTheme();
  const { t } = useTranslation();

  const [headerState, setHeaderState] = useState<
    "search" | "new-message" | null
  >(null);

  const checkedChange = useCallback(
    (value: "search" | "new-message" | null) => {
      if (headerState === "search") {
        setSelectedDateTime(null);
        setSearchString("");
      }
      setHeaderState(headerState === value ? null : value);
    },
    [headerState, setSearchString, setSelectedDateTime],
  );

  return (
    <>
      <VStack
        alignItems="space-between"
        p={2}
        gap={2}
        width="100%"
        borderBottom={`1px solid ${theme.colorOutlineSecondary}`}
      >
        <Flex width="100%" justifyContent="space-between" alignItems="center">
          <SectionButton
            variant="primary"
            checked={headerState === "new-message"}
            onCheckedChange={() => checkedChange("new-message")}
            label={t("Ny melding")}
            height="42px"
          />
          <SectionButton
            checked={headerState === "search"}
            onCheckedChange={() => checkedChange("search")}
            alerts={0}
            icon={<SearchOutline24Icon />}
            label={t("Søk")}
            height="42px"
            fontSize="18px"
          />
        </Flex>

        {headerState === "search" && <OploggSearch />}

        {searchString.length >= 2 && data && (
          <SearchResultText
            searchHits={sum(data.pages.flatMap((it) => it.entries.length))}
            cancelSearch={() => setSearchString("")}
          />
        )}
      </VStack>

      {headerState === "new-message" && (
        <OploggSendMessage setHeaderState={setHeaderState} />
      )}
    </>
  );
};
